<template lang="pug">
  .establishment-map(ref="establishmentMap")
</template>

<script>
import { TEST_SHEET_AGGREGATES } from '../../tests/mocks/sheets.js';
import tmapsHelpers from '@/mixins/tmapsHelpers.js';

export default {
  mixins: [tmapsHelpers],
  props: {
    establishmentSheets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tmap: null,
      map: null,
      TMAPS_API_KEY: 'raccourci',
      establishmentMarkersCluster: null,
      establishmentSheetMarkersCluster: null,
      establishmentMarkers: [],
      hoveredSheet: null,
    };
  },
  watch: {
    establishmentSheets() {
      this.addAllSheetMarkers();
    },
  },
  mounted() {
    this.generateMap().then(() => {
      this.addAllSheetMarkers();
    });
  },
  methods: {
    async generateMap() {
      const { tm, map } = touristicmaps(this.$refs.establishmentMap, this.TMAPS_API_KEY, 566);
      this.map = map;
      this.tmaps = await tm;
    },
    generateMarker({ lat, lng, disabled, count }) {
      return L.marker([lat, lng], { count, icon: disabled ? this.disabledMarkerIcon(count) : this.markerIcon(count) });
    },
    generateAllSheetMarkers() {
      const establishmentSheetMarkers = this.establishmentSheets
        .reduce((acc, sheet) => {
          const existingMarker = acc.find(marker => marker.lat === sheet.lat && marker.lng === sheet.lng);
          if (existingMarker) {
            existingMarker.count++;
            return acc;
          }
          if (sheet.lat && sheet.lng) {
            acc.push({
              lat: sheet.lat,
              lng: sheet.lng,
              count: 1,
            });
          }
          return acc;
        }, [])
        .map(marker => {
          const newMarker = this.generateMarker({ lat: marker.lat, lng: marker.lng, disabled: true, count: marker.count })
          return newMarker;
        });
      this.establishmentSheetMarkersCluster = L.markerClusterGroup({ iconCreateFunction: this.sheetClusterIconCreateFunction });
      this.establishmentSheetMarkersCluster.addLayers(establishmentSheetMarkers);
    },
    addAllSheetMarkers() {
      this.generateAllSheetMarkers();
      this.establishmentSheetMarkersCluster.addTo(this.map);
      this.zoomToFitAllMarkers();
    },
    hoverSheet(sheet) {
      this.hoveredSheet = sheet;
      const correspondingMarker = sheet ? this.establishmentSheetMarkersCluster.getLayers().find(it => it._latlng.lat === sheet.lat && it._latlng.lng === sheet.lng) : null;
      if (correspondingMarker) {
        correspondingMarker.setIcon(this.markerIcon(correspondingMarker.options.count));
      } else {
        this.establishmentSheetMarkersCluster.getLayers().forEach(marker => {
          marker.setIcon(this.disabledMarkerIcon(marker.options.count));
        });
      }
      this.establishmentSheetMarkersCluster.refreshClusters();
    },
    generateEstablishmentMarkers(establishment) {
      if (this.establishmentMarkersCluster) {
        this.establishmentMarkersCluster.clearLayers();
      }
      let establishmentMarkers; 
      if (establishment && establishment.coordinates) {
        establishmentMarkers = establishment.coordinates
          .reduce((acc, coord) => {
            const existingCoord = acc.find(it => it.lat === coord[1] && it.lng === coord[0]);
            if (existingCoord) {
              existingCoord.count++;
              return acc;
            }
            acc.push({ lat: coord[1], lng: coord[0], count: 1 })
            return acc;
          }, [])
          .map(coord => {
            return this.generateMarker({ ...coord, disabled: false });
          });
      } else {
        establishmentMarkers = [];
      }
      if (!this.establishmentMarkersCluster) {
        this.establishmentMarkersCluster = L.markerClusterGroup({ iconCreateFunction: this.clusterIconCreateFunction });
      }
      this.establishmentMarkersCluster.addLayers(establishmentMarkers)
    },
    addEstablishmentMarkers(establishment) {
      this.generateEstablishmentMarkers(establishment);
      if (establishment || !this.establishmentMarkers.length) {
        this.zoomToFitAllMarkers();
      }
      this.establishmentMarkersCluster.addTo(this.map);
    },
    zoomToFitAllMarkers() {
      if (this.establishmentSheetMarkersCluster) {
        const allMarkersGroup = new L.featureGroup(this.establishmentSheetMarkersCluster.getLayers()
          .concat(this.establishmentMarkersCluster ? this.establishmentMarkersCluster.getLayers() : []));
        if (Object.values(allMarkersGroup._layers).length) {
          this.map.flyToBounds(allMarkersGroup.getBounds().pad(0.5), { animate: true, duration: 0.3 });
        }
      }
    },
  },
}
</script>

<style lang="scss">
  .establishment-map {
    width: 36em;
    height: 100%;
    .leaflet-marker-icon {
      width: 0!important;
      height: 0!important;
      border: none;
    }
    .leaflet-control-container {
      display: none;
    }
  }
</style>